export default "__VITE_ASSET__780410ed__"